// extracted by mini-css-extract-plugin
module.exports = {"pageLoading":"pageLoading--2iiIbUPc","spin":"spin--1tVIF68w"};